// Central company config — single source of truth. Update here only.
export const company = {
  name: 'Plaza Turizm',
  legalTagline: 'Kurumsal Çözümlerde Doğru Nokta.',
  brandLine: 'Şirketiniz hareket eder. Biz her adımı yönetiriz.',
  founded: 1992,
  phone: '444 58 58',
  phoneHref: 'tel:+904445858',
  email: 'info@plazatur.com',
  domain: 'www.plazatur.com',
  address: {
    line: 'Kükürtlü Mah. Oulu Cad. No:33/A',
    zipCity: '16080 Osmangazi / Bursa',
    country: 'Türkiye'
  },
  social: {
    linkedin: 'https://tr.linkedin.com/company/plazatur',
    instagram: 'https://www.instagram.com/plazaturbursa/',
    youtube: 'https://www.youtube.com/@plazatur'
  }
};

// Verified metrics only. verified:false => never render as current fact.
export const companyFacts = [
  { value: 1992, suffix: '1992', label: 'Kuruluş', verified: true, sourceYear: 1992, note: '', isText: true },
  { value: 500, suffix: '+', label: 'Gerçekleştirilen organizasyon', verified: true, sourceYear: null, note: 'güncel şirket doğrulamasına bağlı' },
  { value: 500000, suffix: '+', label: 'Organizasyon deneyiminde ulaşılan kişi', verified: true, sourceYear: null, note: 'güncel şirket doğrulamasına bağlı' },
  { value: 0, suffix: '7/24', label: 'Operasyon yaklaşımı', verified: true, sourceYear: null, note: 'güncel şirket doğrulamasına bağlı', isText: true },
  // Example of unverified figures that must NOT be shown as current facts:
  { value: 0, suffix: '', label: 'Çalışan sayısı', verified: false, sourceYear: null },
  { value: 0, suffix: '', label: 'Araç filosu', verified: false, sourceYear: null }
];

export const officeLocations = [
  { city: 'Bursa', role: 'Merkez Ofis', address: 'Kükürtlü Mah. Oulu Cad. No:33/A, 16080 Osmangazi', verified: true, lat: 40.19, lng: 29.06 },
  // Global partner/office data only when verified:true
  { city: 'Global Ağ', role: 'Uluslararası Partner Yapısı', address: '', verified: false }
];

export const navLinks = [
  { label: 'Anasayfa', to: '/' },
  { label: 'Kurumsal Seyahat Yönetimi', to: '/kurumsal-seyahat-yonetimi', mega: true },
  { label: 'Teknolojimiz', to: '/plaza-flow' },
  { label: 'Plazette', to: '/plazette' },
  { label: 'Hakkımızda', to: '/hakkimizda' },
  { label: 'İletişim', to: '/iletisim' }
];

export const megaMenu = [
  {
    title: '',
    items: [
      { label: 'Uçak Bileti', to: '/ucak-bileti' },
      { label: 'Konaklama', to: '/otel-konaklama' },
      { label: 'Araç Kiralama', to: '/arac-kiralama' }
    ]
  },
  {
    title: '',
    items: [
      { label: 'Vize Hizmetleri', to: '/vize-hizmetleri' },
      { label: 'Seyahat Sigortası', to: '/seyahat-sigortasi' },
      { label: 'Etkinlik / MICE', to: '/etkinlik-organizasyon' },
      { label: 'VIP Transfer', to: '/vip-transfer' }
    ]
  }
];
